/**
 * Splits cards into rows of at most `perRow`, as evenly as the count allows: four cards in rows of
 * three print as two and two, not three and a lone one. Each card then stretches across its row, so
 * a section with only some of its cards chosen still fills the page's width.
 */
export const balancedRows = <T>(items: readonly T[], perRow: number): T[][] => {
    const rowCount = Math.ceil(items.length / perRow);
    const base = Math.floor(items.length / rowCount);
    const longer = items.length % rowCount;
    const rows: T[][] = [];
    let start = 0;
    for (let row = 0; row < rowCount; row += 1) {
        const size = row < longer ? base + 1 : base;
        rows.push(items.slice(start, start + size));
        start += size;
    }
    return rows;
};
